import { render, staticRenderFns } from "./HealthActivitiesPanel.vue?vue&type=template&id=40a9d548&"
import script from "./HealthActivitiesPanel.vue?vue&type=script&lang=ts&"
export * from "./HealthActivitiesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports